import { api } from "./client";

/**
 * Интерфейс за един запис от data масива - данни по станция и дата
 * Съдържа разбивка на суми по cash/card за конкретна дата
 */
/**
 * Сума/брой по метод на плащане — КАКТО Е ПЛАТЕНА сметката
 * (смесеното е собствен метод с пълната си сума)
 */
export interface StationMethodAmount {
  payment_method_id: number;
  amount: number;
  count: number;
}

export interface StationDataItem {
  id: number;
  stationName: string;
  date: string;
  total: number;
  card: number;
  cash: number;
  methods: StationMethodAmount[];
}

/**
 * Интерфейс за summary запис - обобщени данни по станция за целия период
 * Включва общи суми и бройки по метод на плащане
 */
export interface StationSummaryItem {
  stationName: string;
  totalCash: number;
  totalCard: number;
  total: number;
  countCash: number;
  countCard: number;
  countMixed: number;
  methods: StationMethodAmount[];
}

/**
 * Отговор от API-то за справка по станции
 * data - детайлни данни по дати за всяка станция
 * summary - обобщение по станция за целия период
 */
export interface StationReportResponse {
  data: StationDataItem[];
  summary: StationSummaryItem[];
}

/**
 * Филтри за заявката - start_date и end_date в ISO 8601 формат
 * Без параметри връща всички данни без ограничение по дата
 */
export interface StationReportFilters {
  start_date?: string;
  end_date?: string;
  /** Само сметките на тези сервитьори (`Bill.waiter_id`); празно = всички. */
  user_ids?: number[];
}

/**
 * Извлича справка по станции от API-то
 * GET /reports/analytics/stations
 * @param filters - опционални филтри за начална и крайна дата
 * @returns обект с data (по дати) и summary (обобщение по станция)
 */
export const getStationsReport = async (
  filters?: StationReportFilters,
): Promise<StationReportResponse> => {
  const params = new URLSearchParams();

  // Добавяме филтри за дати ако са подадени
  if (filters?.start_date) params.append("start_date", filters.start_date);
  if (filters?.end_date) params.append("end_date", filters.end_date);
  for (const id of filters?.user_ids ?? []) params.append("user_ids", String(id));

  const queryString = params.toString();
  const url = `/reports/analytics/stations${queryString ? `?${queryString}` : ""}`;

  const response = await api.get<StationReportResponse>(url);
  return response.data;
};
